import { Component, Input } from '@angular/core';
import { EventDateTimeDto } from '../../shared/new/eventDateTime.model';

@Component({
  selector: 'wl-events-v4-event-dates-edit',
  templateUrl: './events-v4-event-dates-edit.component.html',
  styleUrl: './events-v4-event-dates-edit.component.less',
    standalone: false
})
export class EventsV4EventDatesEditComponent {
  @Input() eventDateTimes: Array<EventDateTimeDto>;
}
